import { render, staticRenderFns } from "./PrehistoricStory.vue?vue&type=template&id=7159ca7c&scoped=true&"
import script from "./PrehistoricStory.vue?vue&type=script&lang=js&"
export * from "./PrehistoricStory.vue?vue&type=script&lang=js&"
import style0 from "./PrehistoricStory.vue?vue&type=style&index=0&id=7159ca7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7159ca7c",
  null
  
)

export default component.exports